var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 15.9998C32 14.0427 31.6479 12.1679 31.0048 10.4346L16 9.73895L0.995188 10.4346C0.352063 12.1679 0 14.0427 0 15.9998C0 17.9569 0.352063 19.8318 0.995188 21.565L16 22.2607L31.0048 21.5651C31.6479 19.8318 32 17.9569 32 15.9998Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 32C22.8796 32 28.7443 27.658 31.005 21.5652H0.995361C3.25605 27.658 9.12074 32 16.0002 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.995361 10.4348H31.005C28.7443 4.342 22.8796 0 16.0002 0C9.12074 0 3.25605 4.342 0.995361 10.4348V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1742 11.1307H17.3916L17.8554 7.65236L19.7104 6.26105L21.5655 7.65236V10.435L20.1742 11.1307Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8261 11.1307H14.6087L14.1449 7.65236L12.2898 6.26105L10.4348 7.65236V10.435L11.8261 11.1307Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8548 11.1307H14.1445V7.65236L15.9997 6.26105L17.8548 7.65236V11.1307Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 10.4349V18.087C10.4348 19.9091 11.3149 21.5294 12.6724 22.5452L13.6464 22.3016L14.8754 23.5379C15.2388 23.6128 15.6149 23.6522 16.0001 23.6522C16.3832 23.6522 16.7574 23.6133 17.1189 23.5392L18.5218 22.3711L19.3276 22.543C20.6845 21.5272 21.5653 19.9086 21.5653 18.087V10.4349H10.4348Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 10.4348H12.6609V12.6608H10.4348V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8865 10.4348H17.1126V12.6608H14.8865V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3394 10.4348H21.5654V12.6608H19.3394V10.4348Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 12.6607H14.8867V14.8867H12.6606V12.6607Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 12.6607H19.3396V14.8867H17.1135V12.6607Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 14.8861H12.6609V17.1121H10.4348V14.8861Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 17.1125H14.8867V19.3386H12.6606V17.1125Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8865 14.8861H17.1126V17.1121H14.8865V14.8861Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3394 14.8861H21.5654V17.1121H19.3394V14.8861Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 17.1125H19.3396V19.3386H17.1135V17.1125Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8865 19.3384H17.1126V21.5645H14.8865V19.3384Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6611 19.3387H10.5786C10.7696 20.1662 11.1451 20.9233 11.66 21.5647H12.6611V19.3387Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3394 21.5648H20.3404C20.8554 20.9234 21.2307 20.1662 21.4217 19.3387H19.3394V21.5648Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6606 21.5646V22.5359C13.3081 23.0231 14.0647 23.3724 14.8867 23.5401V21.5646H12.6606Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1135 21.5646V23.5401C17.9356 23.3726 18.6922 23.0231 19.3396 22.5359V21.5646H17.1135Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/croatia.39dde2f3.svg";
export { ForwardRef as ReactComponent };